import { render, staticRenderFns } from "./ChatPrivateNotes.vue?vue&type=template&id=10756146&"
import script from "./ChatPrivateNotes.vue?vue&type=script&lang=ts&"
export * from "./ChatPrivateNotes.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPrivateNotes.vue?vue&type=style&index=0&id=10756146&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports